<template>
  <div v-loading="fullscreenLoading">
    <div style="margin-left: 10.5%">
      <div style="padding-top: 20px"></div>
      <div
        class="Rectangle-5"
        v-bind:style="{ height: +(windowHeight - 200) + 'px' }"
      >
        <div style="padding: 3%">
          <div>
            <el-table
              :data="tableDataList"
              :height="windowHeight - 450"
              style="width: 100%"
              stripe
            >
              <el-table-column
                prop="type"
                label="广告位置"
                width="300"
              ></el-table-column>
              <el-table-column label="图片(345px X 82px)">
                <template slot-scope="scope">
                  <img
                    style="width: 345px; height: 82px"
                    :src="scope.row.imgUrl"
                  />
                </template>
              </el-table-column>

              <el-table-column fixed="right" label="操作" width="250">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogWithData(scope, 'edit')"
                    >编辑</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top: 20px"></div>
        </div>
      </div>

      <el-dialog
        title="图片操作"
        :visible.sync="boolAddNew"
        width="50%"
        style="text-align: left"
        :before-close="onDialogBoolAddNewClose"
      >
        <div style="margin-top: 20px">
          <div
            style="
              display: inline-block;
              text-align: left;
              width: 10%;
              vertical-align: top;
            "
          >
            图片
          </div>
          <div style="display: inline-block; width: 70%">
            <el-upload
              accept=".jpg, .jpeg, .png"
              class="avatar-uploader"
              :show-file-list="false"
              action="https://freshgo.top/api/public/api/v1/uploadFileQiniu"
              :on-success="onImgUpload"
              :on-remove="onImgRemove"
            >
              <img v-if="form.imgUrl" :src="form.imgUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>

        <div style="text-align: right; margin-top: 20px">
          <el-button
            @click="onEditConfirm()"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >确认</el-button
          >
          <el-button
            @click="onDialogBoolAddNewClose()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >取消</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "adModify",
  data() {
    return {
      fullscreenLoading: false,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,

      searchKeyword: "",

      currentData: {},
      currentPage: 1,

      tableDataList: [],
      tableDataTotal: 0,
      boolAddNew: false,
      boolEdit: false,
      boolDelete: false,

      form: {
        imgUrl: "",
      },
    };
  },
  mounted() {},
  created() {
    this.onCheckloginRole();
    this.onFetchTableData();
  },
  methods: {
    // check if  login
    onCheckloginRole() {
      // var temp = localStorage.getItem("auth");
      // if (temp == undefined || temp != "b60afdc1f3657130c165d32743603a59") {
      //   this.$router.push("/login");
      // }
      var temp = localStorage.getItem("auth");
      this.axios
        .post(this.$urlGlobal + "adminCheck", {
          auth: temp,
        })
        .then((res) => {
          if (res.data.code == -1) {
            this.$router.push("/login");
            localStorage.removeItem("auth");
            window.location.reload();
          }
        });
    },

    // search  table by name
    onSearchTableData() {
      // init the page and fetch data
      this.currentPage = 1;
      this.onFetchTableData();
    },
    // fetch table data also with condition
    onFetchTableData() {
      this.fullscreenLoading = true;
      this.axios.post(this.$urlGlobal + "adminFetchAd", {}).then((res) => {
        this.fullscreenLoading = false;
        this.tableDataList = res.data.data;
      });
    },

    // add new  operation
    onDialogBoolAddNewOpen() {
      this.boolAddNew = true;
    },
    onDialogBoolAddNewClose() {
      this.boolAddNew = false;
      // also close edit because they use same form
      this.boolEdit = false;
      this.form = {
        imgUrl: "",
      };
    },

    // edit  operation
    onDialogBoolEditOpen() {
      this.boolAddNew = true;
      this.boolEdit = true;
      this.form = {
        imgUrl: this.currentData.imgUrl,
      };
    },
    onEditConfirm() {
      if (this.form.imgUrl == "") {
        this.$message({
          message: "尚有未填信息",
          type: "warning",
        });
        return;
      }
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminEditAd", {
          id: this.currentData.id,
          imgUrl: this.form.imgUrl,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == 1) {
            this.$message({
              message: "修改失败",
              type: "warning",
            });
            return;
          } else {
            this.$message({
              message: "修改成功",
              type: "success",
            });
          }
          this.onDialogBoolAddNewClose();
          this.onFetchTableData();
        });
    },

    // image operation
    onImgRemove(file, fileList) {
      this.form.imgUrl = "";
    },
    onImgUpload(file) {
      this.form.imgUrl = file.data;
    },

    // delete  operation
    onDialogBoolDeleteOpen() {
      this.boolDelete = true;
    },
    onDialogBoolDeleteClose() {
      this.boolDelete = false;
    },
    onDeleteConfirm() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminDeleteAd", {
          id: this.currentData.id,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.onDialogBoolDeleteClose();
          this.onFetchTableData();
        });
    },

    // table operation
    onDialogWithData(scope, e) {
      this.currentData = scope.row;
      switch (e) {
        case "edit":
          this.onDialogBoolEditOpen();
          break;
      }
    },
  },
};
</script>

